import { create } from 'zustand'

interface PickIntentStore {
    sharedUrl: string | null
    timestamp: number | null
    isSyncingFromNative: boolean
    pendingSilentCount: number
    pendingPicks: string[] // 🆕 Waiting room for shared links
    isFirstLaunch: boolean
    isSavingPick: boolean // 🛡️ Lock to prevent background syncs from wiping optimistic UI
    setSyncing: (isSyncing: boolean, count?: number) => void
    addPendingPick: (url: string) => void
    removePendingPick: (url: string) => void
    setIsSavingPick: (isSaving: boolean) => void
    decrementSyncingCount: () => void
    setFirstLaunchProcessed: () => void
    setSharedUrl: (url: string | null) => void
    clearSharedUrl: () => void
}

export const usePickIntentStore = create<PickIntentStore>((set) => ({
    sharedUrl: null,
    timestamp: null,
    isSyncingFromNative: false,
    pendingSilentCount: 0,
    pendingPicks: [],
    isFirstLaunch: true,
    isSavingPick: false,
    setSyncing: (isSyncing, count = 0) => set(() => ({ 
        isSyncingFromNative: isSyncing, 
        pendingSilentCount: isSyncing ? count : 0 
    })),
    addPendingPick: (url) => set((state) => ({ 
        pendingPicks: Array.from(new Set([...state.pendingPicks, url]))
    })),
    removePendingPick: (url) => set((state) => ({ 
        pendingPicks: state.pendingPicks.filter(p => p !== url)
    })),
    setIsSavingPick: (isSaving) => set({ isSavingPick: isSaving }),
    decrementSyncingCount: () => set((state) => ({
        pendingSilentCount: Math.max(0, state.pendingSilentCount - 1)
    })),
    setFirstLaunchProcessed: () => set({ isFirstLaunch: false }),
    setSharedUrl: (url) => {
        console.log('📦 Store: setting sharedUrl:', url)
        set({ sharedUrl: url, timestamp: Date.now() })
    },
    clearSharedUrl: () => {
        console.log('📦 Store: clearing sharedUrl')
        set({ sharedUrl: null, timestamp: null })
    }
}))
